<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="width"
    :height="height"
    viewBox="0 0 72 72"
    style="enable-background:new 0 0 72 72;"
    xml:space="preserve"
  >
    <g>
      <g>
        <circle
          class="st0"
          cx="36"
          cy="36"
          r="33.29"
        />
      </g>
    </g>
    <g>
      <path
        class="st1"
        d="M36,3.35C17.97,3.35,3.35,17.97,3.35,36c0,18.04,14.62,32.65,32.65,32.65c18.03,0,32.65-14.62,32.65-32.65
    C68.65,17.97,54.03,3.35,36,3.35 M36,4.45C53.4,4.45,67.55,18.6,67.55,36c0,17.4-14.15,31.56-31.55,31.56
    C18.6,67.56,4.45,53.4,4.45,36C4.45,18.6,18.6,4.45,36,4.45"
      />
      <path
        class="st1"
        d="M47.46,55.19h-3.28V30.98l7.95,15.33L47.46,55.19z M42.58,55.19H28.76v-27.3l6.91-13.33l6.91,13.33V55.19z
      M27.15,55.19h-3.28l-4.67-8.88l7.95-15.34V55.19z M36,11.08c-13.74,0-24.92,11.18-24.92,24.92c0,13.75,11.18,
      24.92,24.92,24.92, c13.74,0,24.92-11.18,24.92-24.92C60.92,22.26,49.74,11.08,36,11.08"
      />
      <path
        class="st1"
        d="M36,61.95c-14.31,0-25.95-11.64-25.95-25.95c0-14.31,11.64-25.95,25.95-25.95c14.31,0,25.95,11.64,25.95,25.95
      C61.95,50.31,50.31,61.95,36,61.95 M36,6.38C19.64,6.38,6.38,19.64,6.38,36c0,16.36,13.26,29.62,29.62,29.62
      c16.36,0,29.62-13.26,29.62-29.62C65.62,19.64,52.36,6.38,36,6.38"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'OrangeCircle',
  props: {
    width: {
      type: String,
      default: '40px',
    },
    height: {
      type: String,
      default: '40px',
    },
  },
};
</script>

<style scoped>
.st0 {
  fill:#FFFFFF;
}
.st1 {
  fill:#EE8922;
}
</style>
